import React from 'react';
import { LearningBook } from '../../../../../model/response';
import { LoadingOutlined } from '@ant-design/icons';

interface LearningBookTreeProps {
  setSelectedLearningBook: (selectedLearningBook: LearningBook | null) => void;
  selectedLearningBook: LearningBook | null;
  learningBookFetching: boolean;
  learningBooks: LearningBook[];
}

function AssetTree({
  setSelectedLearningBook,
  selectedLearningBook,
  learningBookFetching,
  learningBooks,
}: LearningBookTreeProps) {
  function handleSelectLearningBook(learningBook: LearningBook | null) {
    setSelectedLearningBook(learningBook);
  }

  return (
    <div className="w-[20%] border-r-1 border-[silver] p-2 flex flex-col h-[calc(100vh-92px)] overflow-y-auto">
      <div className="p-2 flex-1 flex">
        {learningBookFetching ? (
          <div className={'h-8 flex justify-center items-center w-full'}>
            <LoadingOutlined />
          </div>
        ) : learningBooks.length === 0 ? (
          <div className={'h-8 flex justify-center items-center text-sm w-full'}>Danh sách trống</div>
        ) : (
          <ul className="overflow-auto flex flex-col gap-y-4 w-full">
            {learningBooks.map((learningBook) => (
              <li className="w-full" key={learningBook.id}>
                <li
                  className={'list-none block w-full'}
                  onClick={() =>
                    handleSelectLearningBook(selectedLearningBook?.id === learningBook.id ? null : learningBook)
                  }
                >
                  <div
                    className={
                      'hover:bg-[#e6f8ff] p-2 flex justify-between rounded text-left cursor-pointer ' +
                      (selectedLearningBook?.id === learningBook.id ? 'bg-[#e6f8ff]' : 'bg-[#f1f1f1dd]')
                    }
                  >
                    {learningBook.name}
                  </div>
                </li>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default AssetTree;
